import axios from 'axios';

const API_URL = 'https://my.etsy-tools.co.uk/api/auth/';

class AuthService {
  login(user) {
    return axios
      .post('/auth/login', {
        username: user.username,
        password: user.password
      })
      .then(response => {
        if (response.data.token) {
          localStorage.setItem('user', JSON.stringify(response.data));
          console.log('login success');
        } else { 
          console.log('login fail');
          console.log(response);
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('user');
  }

  register(user) {
    return axios.post(API_URL + 'signup', {
      username: user.username,
      email: user.email,
      password: user.password
    });
  }
}

export default new AuthService();